<template>
    <base-container ref="container" :isLoading="loading">
        <el-table
            ref="table"
            header-row-class-name="back-gray1"
            header-cell-class-name="back-gray1"
            :data="treeData"
            border
            fit
            row-key="key"
            default-expand-all
            height="100%"
            :tree-props="{ children: 'children' }"
        >
            <el-table-column
                type="index"
                header-align="center"
                align="center"
                label="序号"
                width="50"
            >
            </el-table-column>
            <el-table-column
                prop="name"
                label="排班资源名称"
                width="270"
                header-align="center"
            >
                <template v-slot="{ row }">
          <span :class="'color-' + getTypeTag(row.type)">
            {{ row.name }}
          </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="type"
                label="类型"
                width="100"
                header-align="center"
                align="center"
            >
                <template v-slot="{ row }">
                    <el-tag size="small" :type="getTypeTag(row.type)" effect="dark">
                        {{ getTypeLabel(row.type) }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="operator"
                label="排班规则设置"
                header-align="left"
                align="left"
            >
                <template v-slot="{ row }">
                    <el-tag
                        :type="getTypeTag(row.type)"
                        class="margin-h5 clickable"
                        :key="i"
                        v-for="(rule, i) in row.rules"
                        closable
                        @close="removeRule(row, rule)"
                        @click="viewRule(row, rule)"
                    >
                        {{ rule.startDate }} 至 {{ rule.endDate }}
                    </el-tag>
                    <el-button
                        type="primary"
                        size="mini"
                        icon="el-icon-plus"
                        circle
                        plain
                        @click="showScheduleRule(row)"
                    >
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <artisan-drawer
            ref="drawer"
            :title="dialog.title"
            :visible.sync="dialog.isShow"
            direction="right"
            size="90%"
            :isLoading="dialog.loading"
        >
            <ScheduleRuleSetting
                ref="setting"
                v-if="dialog.isShow"
                :id="row.id"
                :type="row.type"
                :scheduleRuleId="scheduleRuleId"
            ></ScheduleRuleSetting>
            <template #footer>
                <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-edit-outline"
                    @click="saveRule"
                >
                    保存排班规则
                </el-button>
            </template>
        </artisan-drawer>
    </base-container>
</template>

<script>
import { getScheduleResources, delRule, saveRule } from "@/api/zl/schedule";
import { buildTree } from "@/util/util";
import ScheduleRuleSetting from "./schedule/ScheduleRuleSetting.vue";
export default {
    components: {
        ScheduleRuleSetting,
    },
    data() {
        return {
            loading: false,
            resList: [],
            defaultProps: {
                children: "children",
                label: "name",
            },
            dialog: {
                isShow: false,
                title: "",
                loading: false,
            },
            row: {},
            scheduleRuleId: "",
            view: {
                isShow: false,
                title: "",
                ruleId: "",
            },
        };
    },
    computed: {
        treeData() {
            return buildTree(this.resList, {
                idField: "key",
                parentField: "parentKey",
            });
        },
    },
    created() {
        this.loadData();
    },
    watch: {
        treeData: {
            handler() {
                this.$nextTick(() => {
                    this.$refs.table.doLayout();
                });
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            this.loading = true;
            getScheduleResources()
                .then((res) => {
                    this.resList = res.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getTypeLabel(type) {
            let label = "";
            switch (type) {
                case "hos":
                    label = "院区";
                    break;
                case "dept":
                    label = "科室";
                    break;
                case "room":
                    label = "治疗室";
                    break;
            }
            return label;
        },
        getTypeTag(type) {
            let tag = "primary";
            switch (type) {
                case "hos":
                    tag = "primary";
                    break;
                case "dept":
                    tag = "warning";
                    break;
                case "room":
                    tag = "success";
                    break;
            }
            return tag;
        },
        showScheduleRule(row) {
            this.row = row;
            this.scheduleRuleId = "";
            this.dialog.title = "添加排班规则--" + row.name;
            this.dialog.isShow = true;
        },
        viewRule(row, rule) {
            this.row = row;
            this.scheduleRuleId = rule.id;
            this.dialog.title = "添加排班规则--" + row.name;
            this.dialog.isShow = true;
        },
        saveRule() {
            let rule = this.$refs.setting.getRule();
            if (rule.startDate && rule.endDate && rule.details.length) {
                this.$refs.drawer.confirm({ msg: "确认保存排班规则！" }).then(() => {
                    this.dialog.loading = true;
                    rule.details.forEach((c) => {
                        if(c.appIds) c.appIds = c.appIds.join(",");
                        if(c.ruleIds) c.ruleIds = c.ruleIds.join(",");
                    });
                    saveRule(rule)
                        .then((res) => {
                            this.dialog.loading = false;
                            this.$message({
                                type: "success",
                                message: "保存成功！",
                            });
                            this.dialog.isShow = false;
                            this.loadData();
                        })
                        .catch(() => {
                            this.dialog.loading = false;
                        });
                });
            } else {
                this.$message({
                    type: "warning",
                    message: "请输入排班周期且设置排班规则！",
                });
            }
        },
        removeRule(row, rule) {
            this.$refs.container
                .confirm({ msg: "确认删除？" })
                .then(() => {
                    this.loading = true;
                    return delRule(rule.id);
                })
                .then(() => {
                    for (let index = 0; index < row.rules.length; index++) {
                        if (row.rules[index].id == rule.id) {
                            row.rules.splice(index, 1);
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped></style>
